import type { QuerySpec } from '@helios/powersync-client-core';

/**
 * PRD.267 — Patient Family Allergies & Medications: PowerSync query helpers.
 *
 * Pure grouping/write-plan logic lives in ./patient-family-history-logic (kept
 * import-light for unit tests) and is re-exported here for a single entry point.
 * These queries only ever read the `patient_family_*` tables — family allergies
 * and medications are never surfaced through patient_allergies / patient_medications.
 */

export * from './patient-family-history-logic.js';

// ── QuerySpecs (soft-delete filtered) ──

export function qPatientFamilyHistory(patientId: string): QuerySpec<[string]> {
  return {
    key: ['patient_family_histories', 'by-patient', patientId],
    sql: `SELECT * FROM patient_family_histories WHERE patient_id = ? AND deleted_at IS NULL LIMIT 1`,
    params: [patientId],
    watch: ['patient_family_histories'],
  };
}

export function qPatientFamilyMembers(patientId: string): QuerySpec<[string]> {
  return {
    key: ['patient_family_members', 'by-patient', patientId],
    sql: `SELECT * FROM patient_family_members WHERE patient_id = ? AND deleted_at IS NULL ORDER BY id`,
    params: [patientId],
    watch: ['patient_family_members'],
  };
}

export function qPatientFamilyMemberAllergies(patientId: string): QuerySpec<[string]> {
  return {
    key: ['patient_family_member_allergies', 'by-patient', patientId],
    sql: `SELECT * FROM patient_family_member_allergies WHERE patient_id = ? AND deleted_at IS NULL ORDER BY id`,
    params: [patientId],
    watch: ['patient_family_member_allergies'],
  };
}

export function qPatientFamilyMemberMedications(patientId: string): QuerySpec<[string]> {
  return {
    key: ['patient_family_member_medications', 'by-patient', patientId],
    sql: `SELECT * FROM patient_family_member_medications WHERE patient_id = ? AND deleted_at IS NULL ORDER BY id`,
    params: [patientId],
    watch: ['patient_family_member_medications'],
  };
}
